import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/sports-betting-odds',
  component: () => import('../../routes/SportsBettingOdds.svelte'),
  card: {
    id: 'sports-betting-odds',
    title: 'Sports Betting Odds',
    description: 'Convert between decimal, American, and fractional odds. Calculate parlay payouts, remove the vig, and understand implied probability.',
    icon: 'sports',
    iconBgClass: 'bg-emerald-50',
    iconTextClass: 'text-emerald-600',
    href: '/sports-betting-odds',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Sports Betting Odds Calculator – Parlay, Implied Probability & Vig',
    description: 'Free sports betting odds calculator. Convert between decimal, American (moneyline), and fractional odds. Calculate parlay payouts, remove bookmaker vig, and find true implied probability.',
  },
};

export default meta;
